<template>
  <div id="resumen">
    <v-layout v-if="solicitud !== ''" wrap>
      <v-flex xs3>
        <v-container>
          <v-menu ref="menuDateStart" :close-on-content-click="false" v-model="menuDateStart" :nudge-right="40"
          :return-value.sync="menuDateStart" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaInicio" label="Fecha inicio" readonly></v-text-field>
            <v-date-picker v-model="fechaInicio" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateStart = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateStart.save(fechaInicio)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <v-menu ref="menuDateEnd" :close-on-content-click="false" v-model="menuDateEnd" :nudge-right="40"
          :return-value.sync="menuDateEnd" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-text-field slot="activator" v-model="fechaFin" label="Fecha fin" readonly></v-text-field>
            <v-date-picker v-model="fechaFin" color="error" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuDateEnd = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuDateEnd.save(fechaFin)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-container>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <v-select v-model="selectedUsers" :items="users" item-text="alias" item-value="id"
          label="Usuarios" :disabled="isAllUsers" multiple></v-select>
        </v-container>
      </v-flex>
      <v-flex xs3>
        <v-container>
          <v-checkbox v-model="allUsers" color="primary" label="Seleccionar todos los usuarios" hide-details></v-checkbox>
        </v-container>
      </v-flex>
    </v-layout>
    <v-card v-if="solicitud === 'cajaChica'" class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="backToMenu()">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span>Volver al menu</span>
        </v-tooltip>
        <v-toolbar-title>Movimientos de caja chica</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="downloadCSVReport()">
            <v-icon>get_app</v-icon>
          </v-btn>
          <span>Descargar</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh('cajaChica')">Buscar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search.cajaChica" append-icon="search" label="Buscar" single-line hide-details maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers.cajaChica" :items="registros.cajaChica" :loading="loading" :search="search.cajaChica"
      rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.usuario_creacion }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.tipo }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">$ {{ props.item.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.fecha_registro }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.fecha_actualizacion }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.pagare }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id, props.item.tipo)">{{ props.item.responsiva }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-else-if="solicitud === 'reposicion'" class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="backToMenu()">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span>Volver al menu</span>
        </v-tooltip>
        <v-toolbar-title>Reposiciones de caja chica</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="downloadCSVReport()">
            <v-icon>get_app</v-icon>
          </v-btn>
          <span>Descargar</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh('reposicion')">Buscar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search.reposicion" append-icon="search" label="Buscar" single-line hide-details maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers.reposicion" :items="registros.reposicion" :loading="loading" :search="search.reposicion"
      rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.usuario_creacion }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.tipo_solicitud }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.tipo_pago }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.no_facturas }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">$ {{ props.item.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.fecha_registro }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-else-if="solicitud === 'gastosViaje'" class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="backToMenu()">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span>Volver al menu</span>
        </v-tooltip>
        <v-toolbar-title>Anticipos de viaje</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="downloadCSVReport()">
            <v-icon>get_app</v-icon>
          </v-btn>
          <span>Descargar</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh('gastosViaje')">Buscar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search.gastosViaje" append-icon="search" label="Buscar" single-line hide-details maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers.gastosViaje" :items="registros.gastosViaje" :loading="loading" :search="search.gastosViaje"
      rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.usuario_creacion }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.estado_comprobacion }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.fecha_salida }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.fecha_regreso }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">$ {{ props.item.importe_anticipo.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">$ {{ props.item.importe_comprobado.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">$ {{ props.item.importe_restante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.fecha_registro }}</td>
          <td class="text-xs-center" @click="showDetail(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-container v-else>
      <h3 class="grey--text text-md-center">SELECCIONAR SOLICITUD</h3><br/>
      <v-layout row wrap>
        <v-flex md4 pb-3>
          <v-card class="elevation-0 mx-auto" width="200" color="grey lighten-5">
            <img @click="selectRequest('cajaChica')" src="@/assets/icons/cajaChica.png" height="200" width="auto" style="opacity:0.8">
          </v-card>
        </v-flex>
        <v-flex md4 pb-3>
          <v-card class="elevation-0 mx-auto" width="200" color="grey lighten-5">
            <img @click="selectRequest('reposicion')" src="@/assets/icons/reposicion.png" height="200" width="auto" style="opacity:0.8">
          </v-card>
        </v-flex>
        <v-flex md4 pb-3>
          <v-card class="elevation-0 mx-auto" width="200" color="grey lighten-5">
            <img @click="selectRequest('gastosViaje')" src="@/assets/icons/gastosViaje.png" height="200" width="auto" style="opacity:0.8">
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogDetReq" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetail()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de fondo fijo de caja</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-container fluid>
                  <h3 class="grey--text">GENERAL</h3><br/>
                  <v-radio-group v-model="detalle.cajaChica.area" :mandatory="false" disabled>
                    <div slot="label"><strong>Área</strong></div>
                    <v-radio label="Oficinas administrativas" color="primary" value="oficinas_administrativas"></v-radio>
                    <v-radio label="Oficinas comerciales" color="primary" value="oficinas_comerciales"></v-radio>
                  </v-radio-group>
                  <br/>
                  <h3 class="grey--text">RESPONSABLE</h3><br/>
                  <v-text-field v-model="detalle.cajaChica.nombre" label="Nombre" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.puesto" label="Puesto" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.departamento" label="Departamento" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.oficina" label="Oficina" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.centro" label="Centro de costos" disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">FIRMAS</h3><br/>
                  <v-list three-line dark>
                    <template v-for="(item, i) in detalle.cajaChica.firmas">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalle.cajaChica.firmas.length"></v-divider>
                    </template>
                  </v-list>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container fluid>
                  <h3 class="grey--text">FONDO FIJO</h3><br/>
                  <v-text-field v-model.lazy="detalle.cajaChica.importe" label="Importe" prefix="$" suffix="MXN" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.letra" label="Importe con letra" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.detalle" label="Detalle" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.empresa" label="Empresa" disabled></v-text-field>
                  <v-text-field v-model="detalle.cajaChica.observaciones" label="Observaciones" disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">DOCUMENTOS</h3><br/>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-btn block :loading="loading" color="blue-grey" class="white--text" @click="downloadData('pagare')">
                        Pagaré
                        <v-icon right dark>cloud_download</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <v-btn block :loading="loading" color="blue-grey" class="white--text" @click="downloadData('responsiva')">
                        Carta responsiva
                        <v-icon right dark>cloud_download</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetInc" persistent width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de incremento de caja</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <h3 class="grey--text">GENERAL</h3><br/>
            <v-text-field v-model="detalle.cajaChica.incremento.importe" label="Nuevo Importe" prefix="$" suffix="MXN" disabled></v-text-field><br/>
            <v-text-field v-model="detalle.cajaChica.incremento.letra" label="Importe con letra" disabled></v-text-field><br/>
            <v-text-field v-model="detalle.cajaChica.incremento.observaciones" label="Observaciones" disabled></v-text-field><br/>
            <h3 class="grey--text">DOCUMENTOS</h3><br/>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDataInc('pagare')">
                  Pagaré
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-btn block flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDataInc('responsiva')">
                  Carta responsiva
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout><br/>
            <h3 class="grey--text">FIRMAS</h3><br/>
            <v-list three-line dark>
              <template v-for="(item, i) in detalle.cajaChica.incremento.firmas">
                <v-list-tile class="pb-2 pt-2">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                    <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                    <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-show="(i + 1) < detalle.cajaChica.incremento.firmas.length"></v-divider>
              </template>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeDetail()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetRep" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetail()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de reposición fondo fijo de caja</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">GENERAL</h3><br/>
                  <v-radio-group v-model="detalle.reposicion.general.tipo_solicitud" disabled>
                    <div slot="label"><strong>Tipo de solicitud</strong></div>
                    <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                    <v-radio label="Depósito electrónico" color="primary" value="deposito_electronico"></v-radio>
                  </v-radio-group>
                  <v-radio-group v-model="detalle.reposicion.general.tipo_pago" disabled>
                    <div slot="label"><strong>Tipo de pago</strong></div>
                    <v-radio label="Gastos comprobables" color="primary" value="gastos_comprobables"></v-radio>
                    <v-radio label="Otros" color="primary" value="otros"></v-radio>
                  </v-radio-group><br/>
                  <v-text-field v-model="detalle.reposicion.solicitud.monto" box prefix="$" suffix="MXN" label="Fondo fijo autorizado" disabled></v-text-field>
                  <br/>
                  <template v-if="detalle.reposicion.general.tipo_solicitud === 'deposito_electronico'">
                    <h3 class="grey--text">DATOS DE DEPÓSITO</h3><br/>
                    <v-text-field v-model="detalle.reposicion.general.banco" box label="Banco" disabled></v-text-field>
                    <v-text-field v-model="detalle.reposicion.general.cuenta" box label="No. Cuenta" disabled></v-text-field>
                    <v-text-field v-model="detalle.reposicion.general.tarjeta" box label="No. Tarjeta" disabled></v-text-field>
                    <v-text-field v-model="detalle.reposicion.general.clabe" box label="Referencia interbancaria" disabled></v-text-field><br/>
                  </template>
                  <h3 class="grey--text">FIRMAS</h3><br/>
                  <v-list three-line dark>
                    <template v-for="(item, i) in detalle.reposicion.firmas">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalle.reposicion.firmas.length"></v-divider>
                    </template>
                  </v-list>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DE CAJA CHICA</h3><br/>
                  <v-text-field v-model="detalle.reposicion.solicitud.empresa" label="Empresa" box disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br/>
                  <v-text-field v-model="detalle.reposicion.usuario.unidad" label="Unidad de negocio" box disabled></v-text-field>
                  <v-text-field v-model="detalle.reposicion.usuario.plaza" label="Plaza" box disabled></v-text-field>
                  <v-text-field v-model="detalle.reposicion.solicitud.centro" label="Centro de costos" box disabled></v-text-field>
                  <v-text-field v-model="detalle.reposicion.usuario.beneficiario" label="Beneficiario" box disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">FACTURAS</h3><br/>
                  <v-text-field v-model="detalle.reposicion.resumen.no_facturas" class="pt-3" label="No. Facturas" box disabled></v-text-field>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-btn small block color="blue-grey" class="white--text" disabled>
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn><br/>
                      <v-text-field v-model="detalle.reposicion.resumen.subtotal" label="Subtotal" box prefix="$" suffix="MXN" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <div class="text-xs-center">
                        <v-menu transition="slide-y-transition" top left offset-y full-width>
                          <v-btn slot="activator" :disabled="detalle.reposicion.facturas.length == 0" small block color="blue-grey" class="white--text">
                            Mostrar
                            <v-icon small right dark>remove_red_eye</v-icon>
                          </v-btn>
                          <v-list v-if="detalle.reposicion.facturas.length > 0">
                            <v-list-tile v-for="(fac, idx) in detalle.reposicion.facturas" :key="idx" @click="showFacDetailRep(idx)">
                              <v-list-tile-title v-text="fac.concepto"></v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div><br/>
                      <v-text-field v-model="detalle.reposicion.resumen.iva" label="IVA" box prefix="$" suffix="MXN" disabled></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field v-model="detalle.reposicion.general.importe_total" label="Importe por reembolsar" prefix="$" suffix="MXN" box disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">RESUMEN</h3><br/>
                  <v-data-table v-if="tableResumenRep.length" :headers="headersResumen" :items="tableResumenRep" class="elevation-1" hide-actions no-data-text="">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-right">{{ props.item.tipo_gasto }}</td>
                      <td class="text-xs-right">{{ props.item.concepto }}</td>
                      <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                      <td class="text-xs-right">{{ props.item.proveedor }}</td>
                      <td class="text-xs-right">{{ props.item.subtotal }}</td>
                      <td class="text-xs-right">{{ props.item.iva }}</td>
                      <td class="text-xs-right">{{ props.item.total }}</td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetFac" width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de Factura</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ detalle.reposicion.detalle_factura.index + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="detalle.reposicion.detalle_factura.tipo_gasto" :mandatory="false" disabled>
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocumentRep('pdf')">
                  PDF
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocumentRep('xml')">
                  XML
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocumentRep('foto')">
                  Foto
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout><br/>
            <v-text-field v-model="detalle.reposicion.detalle_factura.concepto" class="pt-4" label="Concepto" disabled></v-text-field>
            <v-btn v-if="esConceptoPorDefinir(detalle.reposicion.detalle_factura.concepto)" flat :loading="loading" color="blue-grey" class="white--text"
            @click="abrirNuevoConcepto(detalle.reposicion.detalle_factura.id)">
              Actualizar concepto
            </v-btn>
            <v-text-field v-model="detalle.reposicion.detalle_factura.centro" class="pt-4" label="Centro de costos" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.razon_social" class="pt-4" label="Razón Social" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.rfc" class="pt-4" label="RFC" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.no_factura" class="pt-4" label="No. Factura" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.importe" class="pt-4" label="Importe" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.descuento" class="pt-4" label="Descuento" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.iva" class="pt-4" label="IVA" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalle.reposicion.detalle_factura.total" class="pt-4" label="Total" prefix="$" suffix="MXN" disabled></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeDetailFac()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetAnt" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetail()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de autorización y anticipo de viaje</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br/>
                  <v-text-field v-model="detalle.gastosViaje.beneficiario" label="Beneficiario" box disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.puesto" label="Puesto" box disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.empresa" label="Empresa" box disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.plaza" label="UEN / Plaza" box disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.departamento" label="Departamento" box disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.centro" label="Centro de costos" disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">DATOS GENERALES DEL ANTICIPO</h3><br/>
                  <v-radio-group v-model="detalle.gastosViaje.tipo_solicitud" :mandatory="false" disabled>
                    <div slot="label"><strong>Tipo de solicitud</strong></div>
                    <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                    <v-radio label="Transferencia" color="primary" value="transferencia"></v-radio>
                  </v-radio-group>
                  <template v-if="detalle.gastosViaje.tipo_solicitud === 'transferencia'">
                    <v-text-field v-model="detalle.gastosViaje.banco" label="Banco" box disabled></v-text-field>
                    <v-text-field v-model="detalle.gastosViaje.cuenta" label="No. Cuenta" box disabled></v-text-field>
                    <v-text-field v-model="detalle.gastosViaje.tarjeta" label="No. Tarjeta" box disabled></v-text-field>
                    <v-text-field v-model="detalle.gastosViaje.clabe" label="Referencia interbancaria" box disabled></v-text-field><br/>
                  </template>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DEL VIAJE</h3><br/>
                  <v-text-field v-model="detalle.gastosViaje.destino" label="Destino" disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.motivo_viaje" label="Motivo de viaje" disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.fecha_salida" label="Fecha de salida" disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.fecha_regreso" label="Fecha de regreso" disabled></v-text-field>
                  <v-text-field v-model="detalle.gastosViaje.dias_viaje" label="Días de viaje" box disabled></v-text-field>
                  <br/>
                  <v-text-field v-model="detalle.gastosViaje.importe_total" label="Importe total" box prefix="$" suffix="MXN" disabled></v-text-field>
                  <br/>
                  <h3 class="grey--text">COMPROBANTES DE VIAJE</h3><br/>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-btn small block color="blue-grey" class="white--text" :loading="loading" disabled>
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn><br/>
                      <v-text-field v-model="detalle.gastosViaje.resumen.no_comprobantes" label="No. Comprobantes" box readonly></v-text-field>
                      <v-text-field v-model="detalle.gastosViaje.resumen.iva" label="IVA" box prefix="$" suffix="MXN" readonly></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <div class="text-xs-center">
                        <v-menu transition="slide-y-transition" top left offset-y full-width>
                          <v-btn slot="activator" :disabled="detalle.gastosViaje.comprobantes.length == 0" :loading="loading"
                          small block color="blue-grey" class="white--text">
                            Mostrar
                            <v-icon small right dark>remove_red_eye</v-icon>
                          </v-btn>
                          <v-list v-if="detalle.gastosViaje.comprobantes.length > 0">
                            <v-list-tile v-for="(chk, idx) in detalle.gastosViaje.comprobantes" :key="idx" @click="showDetailChk(idx)">
                              <v-list-tile-title v-text="detalle.gastosViaje.conceptos.filter(concepto => { return concepto.id == chk.concepto })[0].descripcion"></v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div><br/>
                      <v-text-field v-model="detalle.gastosViaje.resumen.subtotal" label="Subtotal" box prefix="$" suffix="MXN" readonly></v-text-field>
                      <v-text-field v-model="detalle.gastosViaje.resumen.neto" label="Neto" box prefix="$" suffix="MXN" readonly></v-text-field>
                    </v-flex>
                  </v-layout>
                  <template v-if="(parseFloat(detalle.gastosViaje.importe_total.toString().replace(/\,/g, '')) - parseFloat(detalle.gastosViaje.resumen.neto.toString().replace(/\,/g, ''))) < 0">
                    <v-btn v-if="detalle.gastosViaje.stado != 'Reembolsado'" block :loading="loading" color="blue-grey" class="white--text" disabled>
                      Solicitar reembolso
                      <v-icon right dark>monetization_on</v-icon>
                    </v-btn>
                    <v-btn v-else block color="blue-grey" class="white--text" disabled>
                      Solicitud de reembolso enviada
                      <v-icon right dark>monetization_on</v-icon>
                    </v-btn>
                  </template>
                  <br/>
                  <h3 class="grey--text">RESUMEN</h3><br/>
                  <v-data-table v-if="tableResumenAnt.length" :headers="headersResumen" :items="tableResumenAnt" class="elevation-1" hide-actions no-data-text="">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-right">{{ props.item.tipo_gasto }}</td>
                      <td class="text-xs-right">{{ props.item.concepto }}</td>
                      <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                      <td class="text-xs-right">{{ props.item.proveedor }}</td>
                      <td class="text-xs-right">{{ props.item.subtotal }}</td>
                      <td class="text-xs-right">{{ props.item.iva }}</td>
                      <td class="text-xs-right">{{ props.item.total }}</td>
                    </template>
                  </v-data-table>
                  <br/>
                  <h3 class="grey--text">FIRMAS (ANTICIPO)</h3><br/>
                  <v-list three-line dark>
                    <template v-for="(item, i) in detalle.gastosViaje.firmas_anticipo">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalle.gastosViaje.firmas_anticipo.length"></v-divider>
                    </template>
                  </v-list><br/>
                  <h3 class="grey--text">FIRMAS (COMPROBACIÓN)</h3><br/>
                  <v-list v-if="detalle.gastosViaje.firmas_comprobante.length" three-line dark>
                    <template v-for="(item, i) in detalle.gastosViaje.firmas_comprobante">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalle.gastosViaje.firmas_comprobante.length"></v-divider>
                    </template>
                  </v-list>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetChk" :persistent="true" width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de Comprobante</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ detalle.gastosViaje.detalle_comprobante.index + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="detalle.gastosViaje.detalle_comprobante.tipo_gasto" :mandatory="false" disabled>
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <!--<v-select v-model="detalle.gastosViaje.detalle_comprobante.centro" label="Centro de costos" :items="detalle.gastosViaje.centros"
            item-text="descripcion" item-value="id" box disabled></v-select>-->
            <v-select v-model="detalle.gastosViaje.detalle_comprobante.concepto" label="Concepto" :items="detalle.gastosViaje.conceptos"
            item-text="descripcion" item-value="id" box disabled></v-select>
            <v-select v-model="detalle.gastosViaje.detalle_comprobante.detalle_no" v-show="!detalleGastoDeducible"
            label="Detalle" :items="detalle.gastosViaje.detalles_no" item-text="descripcion" item-value="id" box disabled></v-select>
            <v-btn v-if="esConceptoPorDefinir(detalle.gastosViaje.detalle_comprobante.concepto)" flat :loading="loading" color="blue-grey" class="white--text"
            @click="abrirNuevoConcepto(detalle.gastosViaje.detalle_comprobante.id)">
              Actualizar concepto
            </v-btn>
            <v-layout wrap>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocumentAnt('pdf')">
                  PDF
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocumentAnt('xml')">
                  XML
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocumentAnt('foto')">
                  Foto
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout><br/>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.rfc" v-show="detalleGastoDeducible" label="RFC" box disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.beneficiario" v-show="detalleGastoDeducible" label="Beneficiario" box disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.folio" v-show="detalleGastoDeducible" label="Folio" box disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.uuid" v-show="detalleGastoDeducible" label="UUID" box disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.subtotal" label="Subtotal" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.descuento" label="Descuento" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.iva" label="IVA" prefix="$" suffix="MXN" disabled></v-text-field>
            <v-text-field v-model="detalle.gastosViaje.detalle_comprobante.total" label="Total" prefix="$" suffix="MXN" disabled></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeDetailChk()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewCon" persistent width="450">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nuevo concepto</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-select :key="'sel-'+id_documento" v-model="nuevo_conceptoo" :items="conceptos"
            item-text="descripcion" item-value="id" label="Concepto"></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeNewConcept()">Cerrar</v-btn>
          <v-btn color="blue-grey" class="white--text" @click.native="updateNewConcept()">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import services from '@/config/services'
import download from 'downloadjs'

export default {
  name: 'resumen',
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: '',
    msgError: '',
    dialogDetReq: false,
    dialogDetInc: false,
    dialogDetRep: false,
    dialogDetFac: false,
    dialogDetAnt: false,
    dialogDetChk: false,
    dialogNewCon: false,
    solicitud: '',
    menuDateStart: false,
    menuDateEnd: false,
    fechaInicio: '',
    fechaFin: '',
    users: [],
    selectedUsers: [],
    allUsers: false,
    search: {
      cajaChica: '',
      reposicion: '',
      gastosViaje: ''
    },
    pagination: {
      rowsPerPage: 7
    },
    headers: {
      cajaChica: [
        { text: 'Id. Solicitud', align: 'center', sortable: false, value: 'id_seg' },
        { text: 'Usuario', align: 'center', sortable: false, value: 'usuario_creacion' },
        { text: 'Tipo', align: 'center', sortable: false, value: 'tipo' },
        { text: 'Estado', align: 'center', sortable: false, value: 'estado' },
        { text: 'Importe', align: 'center', sortable: false, value: 'importe' },
        { text: 'Fecha de Registro', align: 'center', sortable: false, value: 'fecha_registro' },
        { text: 'Fecha de Actualización', align: 'center', sortable: false, value: 'fecha_actualizacion' },
        { text: 'Pagaré', align: 'center', sortable: false, value: 'pagare' },
        { text: 'Responsiva', align: 'center', sortable: false, value: 'responsiva' }
      ],
      reposicion: [
        { text: 'Id. Solicitud', align: 'center', sortable: false, value: 'id_seg' },
        { text: 'Usuario', align: 'center', sortable: false, value: 'usuario_creacion' },
        { text: 'Tipo de Solicitud', align: 'center', sortable: false, value: 'tipo_solicitud' },
        { text: 'Tipo de Pago', align: 'center', sortable: false, value: 'tipo_pago' },
        { text: 'No. Facturas', align: 'center', sortable: false, value: 'no_facturas' },
        { text: 'Importe Total', align: 'center', sortable: false, value: 'importe_total' },
        { text: 'Estado', align: 'center', sortable: false, value: 'estado' },
        { text: 'Fecha de Registro', align: 'center', sortable: false, value: 'fecha_registro' },
        { text: 'Fecha de Actualización', align: 'center', sortable: false, value: 'fecha_actualizacion' }
      ],
      gastosViaje: [
        { text: 'Id. Solicitud', align: 'center', sortable: false, value: 'id_seg' },
        { text: 'Usuario', align: 'center', sortable: false, value: 'usuario_creacion' },
        { text: 'Estado de Anticipo', align: 'center', sortable: false, value: 'estado' },
        { text: 'Estado de Comprobación', align: 'center', sortable: false, value: 'estado_comprobacion' },
        { text: 'Fecha de Salida', align: 'center', sortable: false, value: 'fecha_salida' },
        { text: 'Fecha de Regreso', align: 'center', sortable: false, value: 'fecha_regreso' },
        { text: 'Importe de Anticipo', align: 'center', sortable: false, value: 'importe_anticipo' },
        { text: 'Importe Comprobado', align: 'center', sortable: false, value: 'importe_comprobado' },
        { text: 'Importe Restante', align: 'center', sortable: false, value: 'importe_restante' },
        { text: 'Fecha de Registro', align: 'center', sortable: false, value: 'fecha_registro' },
        { text: 'Fecha de Actualización', align: 'center', sortable: false, value: 'fecha_actualizacion' }
      ]
    },
    headersResumen: [
      { text: 'TIPO DE GASTO', align: 'center', sortable: false, value: 'tipo_gasto' },
      { text: 'CONCEPTO', align: 'center', sortable: false, value: 'concepto' },
      { text: 'FECHA DE TIMBRADO', align: 'center', sortable: false, value: 'fecha_timbrado' },
      { text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },
      { text: 'SUB TOTAL', align: 'center', sortable: false, value: 'subtotal' },
      { text: 'IVA', align: 'center', sortable: false, value: 'iva' },
      { text: 'TOTAL', align: 'center', sortable: false, value: 'total' }
    ],
    registros: {
      cajaChica: [],
      reposicion: [],
      gastosViaje: []
    },
    detalle: {
      cajaChica: {
        estado: '',
        area: null,
        nombre: '',
        puesto: '',
        departamento: '',
        oficina: '',
        centro: '',
        importe: '',
        letra: '',
        detalle: '',
        empresa: '',
        observaciones: '',
        firmas: [],
        pagare: { nombre: '', data: null },
        responsiva: { nombre: '', data: null },
        incremento: {
          id: '',
          importe: '',
          letra: '',
          observaciones: '',
          pagare: { nombre: '', data: null },
          responsiva: { nombre: '', data: null },
          firmas: []
        }
      },
      reposicion: {
        solicitud: {
          monto: 0,
          empresa: '',
          centro: ''
        },
        usuario: {
          unidad: '',
          plaza: '',
          beneficiario: ''
        },
        general: {
          tipo_solicitud: null,
          tipo_pago: null,
          monto: '',
          banco: '',
          cuenta: '',
          tarjeta: '',
          clabe: '',
          importe_total: ''
        },
        facturas: [],
        resumen: {
          no_facturas: 0,
          subtotal: 0,
          iva: 0
        },
        firmas: [],
        detalle_factura: {
          index: '',
          id: '',
          tipo_gasto: null,
          pdf: { nombre: '', data: null },
          xml: { nombre: '', data: null },
          foto: { nombre: '', data: null },
          centro: null,
          concepto: '',
          razon_social: '',
          rfc: '',
          no_factura: '',
          proveedor_frontera: false,
          importe: '',
          descuento: '',
          iva: '',
          total: ''
        }
      },
      gastosViaje: {
        id: '',
        beneficiario: '',
        puesto: '',
        empresa: '',
        plaza: '',
        departamento: '',
        centro: '',
        destino: '',
        importe_total: '',
        motivo_viaje: '',
        fecha_salida: '',
        fecha_regreso: '',
        dias_viaje: '',
        ruta_traslado: [],
        tipo_solicitud: null,
        banco: '',
        cuenta: '',
        tarjeta: '',
        clabe: '',
        aerolinea: '',
        hotel: '',
        costo_boleto: '',
        no_noches: '',
        tarifa: '',
        centros: [],
        conceptos: [],
        conceptos_sat: [],
        importe_total: '',
        comprobantes: [],
        resumen: {
          no_comprobantes: 0,
          subtotal: 0,
          iva: 0,
          neto: 0
        },
        detalle_comprobante: {
          index: '',
          id: '',
          tipo_gasto: '',
          centro: null,
          concepto: '',
          detalle_no: '',
          pdf: { nombre: '', data: null },
          xml: { nombre: '', data: null },
          foto: { nombre: '', data: null },
          rfc: '',
          beneficiario: '',
          folio: '',
          uuid: '',
          subtotal: '',
          descuento: '',
          iva: '',
          total: ''
        },
        firmas_anticipo: [],
        firmas_comprobante: []
      }
    },
    conceptos: [],
    id_documento: '',
    nuevo_conceptoo: '',
    idSolicitudActual: '',
    tipoDetalleActual: '',
    csv: []
  }),
  computed: {
    isAllUsers() {
      if (this.allUsers) {
        this.selectedUsers = []
      }
      return this.allUsers
    },
    detalleGastoDeducible() {
      return this.dialogDetChk && this.detalle.gastosViaje.detalle_comprobante.tipo_gasto === 'deducible'
    },
    tableResumenRep() {
      let resumen = []
      let detalle = {}
      for (let i = 0; i < this.detalle.reposicion.facturas.length; i++) {
        let tipo_gasto = this.detalle.reposicion.facturas[i].tipo_gasto
        let concepto = this.detalle.reposicion.facturas[i].concepto
        let fecha_timbrado = this.detalle.reposicion.facturas[i].fecha_timbrado
        let proveedor = this.detalle.reposicion.facturas[i].razon_social
        let subtotal = this.detalle.reposicion.facturas[i].importe
        let iva = this.detalle.reposicion.facturas[i].iva
        let total = this.detalle.reposicion.facturas[i].total
        if (tipo_gasto === 'deducible') {
          tipo_gasto = 'DEDUCIBLE'
        }
        else if (tipo_gasto === 'no_deducible') {
          tipo_gasto = 'NO DEDUCIBLE'
        }
        if (!detalle[tipo_gasto]) {
          detalle[tipo_gasto] = {}
        }
        if (!detalle[tipo_gasto][concepto]) {
          detalle[tipo_gasto][concepto] = {
            fecha_timbrado: fecha_timbrado,
            proveedor: proveedor,
            subtotal: 0,
            iva: 0,
            total: 0
          }
        }
        detalle[tipo_gasto][concepto].subtotal += subtotal
        detalle[tipo_gasto][concepto].iva += iva
        detalle[tipo_gasto][concepto].total += total
      }
      let keysTipoGasto = Object.keys(detalle)
      for (let i = 0; i < keysTipoGasto.length; i++) {
        let keysConcepto = Object.keys(detalle[keysTipoGasto[i]])
        for (let j = 0; j < keysConcepto.length; j++) {
          resumen.push({
            tipo_gasto: keysTipoGasto[i],
            concepto: keysConcepto[j],
            fecha_timbrado: detalle[keysTipoGasto[i]][keysConcepto[j]].fecha_timbrado,
            proveedor: detalle[keysTipoGasto[i]][keysConcepto[j]].proveedor,
            subtotal: detalle[keysTipoGasto[i]][keysConcepto[j]].subtotal,
            iva: detalle[keysTipoGasto[i]][keysConcepto[j]].iva,
            total: detalle[keysTipoGasto[i]][keysConcepto[j]].total
          })
        }
      }
      for (let i = 0; i < resumen.length; i++) {
        resumen[i].fecha_timbrado = resumen[i].fecha_timbrado.split("T")[0]
        resumen[i].subtotal = '$' + resumen[i].subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        resumen[i].iva = '$' + resumen[i].iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        resumen[i].total = '$' + resumen[i].total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      return resumen
    },
    tableResumenAnt() {
      let resumen = []
      let detalle = {}
      for (let i = 0; i < this.detalle.gastosViaje.comprobantes.length; i++) {
        let tipo_gasto = this.detalle.gastosViaje.comprobantes[i].tipo_gasto
        let concepto = ''
        let fecha_timbrado = this.detalle.gastosViaje.comprobantes[i].fecha_timbrado
        let proveedor = this.detalle.gastosViaje.comprobantes[i].beneficiario
        let subtotal = this.detalle.gastosViaje.comprobantes[i].subtotal
        let iva = this.detalle.gastosViaje.comprobantes[i].iva
        let total = this.detalle.gastosViaje.comprobantes[i].total
        for (let j = 0; j < this.detalle.gastosViaje.conceptos.length; j++) {
          if (this.detalle.gastosViaje.conceptos[j].id == this.detalle.gastosViaje.comprobantes[i].concepto) {
            concepto = this.detalle.gastosViaje.conceptos[j].descripcion
          }
        }
        if (tipo_gasto === 'deducible') {
          tipo_gasto = 'DEDUCIBLE'
        }
        else if (tipo_gasto === 'no_deducible') {
          tipo_gasto = 'NO DEDUCIBLE'
        }
        if (!detalle[tipo_gasto]) {
          detalle[tipo_gasto] = {}
        }
        if (!detalle[tipo_gasto][concepto]) {
          detalle[tipo_gasto][concepto] = {
            fecha_timbrado: fecha_timbrado,
            proveedor: proveedor,
            subtotal: 0,
            iva: 0,
            total: 0
          }
        }
        detalle[tipo_gasto][concepto].subtotal += subtotal
        detalle[tipo_gasto][concepto].iva += iva
        detalle[tipo_gasto][concepto].total += total
      }
      let keysTipoGasto = Object.keys(detalle)
      for (let i = 0; i < keysTipoGasto.length; i++) {
        let keysConcepto = Object.keys(detalle[keysTipoGasto[i]])
        for (let j = 0; j < keysConcepto.length; j++) {
          resumen.push({
            tipo_gasto: keysTipoGasto[i],
            concepto: keysConcepto[j],
            fecha_timbrado: detalle[keysTipoGasto[i]][keysConcepto[j]].fecha_timbrado,
            proveedor: detalle[keysTipoGasto[i]][keysConcepto[j]].proveedor,
            subtotal: detalle[keysTipoGasto[i]][keysConcepto[j]].subtotal,
            iva: detalle[keysTipoGasto[i]][keysConcepto[j]].iva,
            total: detalle[keysTipoGasto[i]][keysConcepto[j]].total
          })
        }
      }
      for (let i = 0; i < resumen.length; i++) {
        resumen[i].fecha_timbrado = resumen[i].fecha_timbrado.split("T")[0]
        resumen[i].subtotal = '$' + resumen[i].subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        resumen[i].iva = '$' + resumen[i].iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        resumen[i].total = '$' + resumen[i].total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      return resumen
    }
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getUsers() {
      this.loading = true
      this.ws('get', 'contaUsuarios')
        .then(res => {
          if (res.ok) {
            this.users = res.data.usuarios
          }
          else {
            this.users = []
            this.selectedUsers = []
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectRequest(solicitud) {
      this.solicitud = solicitud
      this.getUsers()
    },
    refresh(solicitud) {
      let dateStart = moment(this.fechaInicio)
      let dateEnd = moment(this.fechaFin)
      let tmpUsers = []
      if (this.allUsers) {
        for (let i = 0; i < this.users.length; i++) {
          tmpUsers.push(this.users[i].id);
        }
      }
      else {
        tmpUsers = this.selectedUsers
      }
      if (dateStart.isValid() && dateEnd.isValid() && tmpUsers.length) {
        let data = {
          fecha_inicio: this.fechaInicio,
          fecha_fin: this.fechaFin,
          usuarios: JSON.stringify(tmpUsers)
        }
        if (this.solicitud === 'cajaChica') {
          this.loading = true
          this.ws('get', 'contaFiltroMovimientosCajaChica', data)
            .then(res => {
              if (res.ok) {
                this.registros.cajaChica = res.data.movimientos
              }
              else {
                this.registros.cajaChica = []
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
        else if (this.solicitud === 'reposicion') {
          this.loading = true
          this.ws('get', 'contaFiltroReposicionesCajaChica', data)
            .then(res => {
              if (res.ok) {
                this.registros.reposicion = res.data.reposiciones
              }
              else {
                this.registros.reposicion = []
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
        else if (this.solicitud === 'gastosViaje') {
          this.loading = true
          this.ws('get', 'contaFiltroAnticiposViaje', data)
            .then(res => {
              if (res.ok) {
                this.registros.gastosViaje = res.data.anticipos
              }
              else {
                this.registros.gastosViaje = []
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
      else {
        this.error = true
        this.msgError = 'Algunos campos se encuentran vacíos'
      }
    },
    backToMenu() {
      this.solicitud = ''
      this.search = {
        cajaChica: '',
        reposicion: '',
        gastosViaje: ''
      }
      this.registros = {
        cajaChica: [],
        reposicion: [],
        gastosViaje: []
      }
      this.fechaInicio = ''
      this.fechaFin = ''
      this.users = []
      this.selectedUsers = []
      this.allUsers = false
    },
    closeDetail() {
      this.detalle = {
        cajaChica: {
          estado: '',
          area: null,
          nombre: '',
          puesto: '',
          departamento: '',
          oficina: '',
          centro: '',
          importe: '',
          letra: '',
          detalle: '',
          empresa: '',
          observaciones: '',
          firmas: [],
          pagare: { nombre: '', data: null },
          responsiva: { nombre: '', data: null },
          incremento: {
            id: '',
            importe: '',
            letra: '',
            observaciones: '',
            pagare: { nombre: '', data: null },
            responsiva: { nombre: '', data: null },
            firmas: []
          }
        },
        reposicion: {
          solicitud: {
            monto: 0,
            empresa: '',
            centro: ''
          },
          usuario: {
            unidad: '',
            plaza: '',
            beneficiario: ''
          },
          general: {
            tipo_solicitud: null,
            tipo_pago: null,
            monto: '',
            banco: '',
            cuenta: '',
            tarjeta: '',
            clabe: '',
            importe_total: ''
          },
          facturas: [],
          resumen: {
            no_facturas: 0,
            subtotal: 0,
            iva: 0
          },
          firmas: [],
          detalle_factura: {
            index: '',
            id: '',
            tipo_gasto: null,
            pdf: { nombre: '', data: null },
            xml: { nombre: '', data: null },
            foto: { nombre: '', data: null },
            centro: null,
            concepto: '',
            razon_social: '',
            rfc: '',
            no_factura: '',
            proveedor_frontera: false,
            importe: '',
            descuento: '',
            iva: '',
            total: ''
          }
        },
        gastosViaje: {
          id: '',
          beneficiario: '',
          puesto: '',
          empresa: '',
          plaza: '',
          departamento: '',
          centro: '',
          destino: '',
          importe_total: '',
          motivo_viaje: '',
          fecha_salida: '',
          fecha_regreso: '',
          dias_viaje: '',
          ruta_traslado: [],
          tipo_solicitud: null,
          banco: '',
          cuenta: '',
          tarjeta: '',
          clabe: '',
          aerolinea: '',
          hotel: '',
          costo_boleto: '',
          no_noches: '',
          tarifa: '',
          centros: [],
          conceptos: [],
          conceptos_sat: [],
          importe_total: '',
          comprobantes: [],
          resumen: {
            no_comprobantes: 0,
            subtotal: 0,
            iva: 0,
            neto: 0
          },
          detalle_comprobante: {
            index: '',
            id: '',
            tipo_gasto: '',
            centro: null,
            concepto: '',
            detalle_no: '',
            pdf: { nombre: '', data: null },
            xml: { nombre: '', data: null },
            foto: { nombre: '', data: null },
            rfc: '',
            beneficiario: '',
            folio: '',
            uuid: '',
            subtotal: '',
            descuento: '',
            iva: '',
            total: ''
          },
          firmas_anticipo: [],
          firmas_comprobante: []
        }
      }
      this.conceptos = []
      this.idSolicitudActual = ''
      this.tipoDetalleActual = ''
      this.dialogDetReq = false
      this.dialogDetInc = false
      this.dialogDetRep = false
      this.dialogDetAnt = false
    },
    closeNewConcept() {
      this.id_documento = ''
      this.nuevo_conceptoo = ''
      this.dialogNewCon = false
    },
    esConceptoPorDefinir(concepto) {
      if (!concepto) return false
      if (typeof concepto === 'object') {
        return concepto.subcuenta === '000000' || /por definir/i.test(concepto.descripcion || '')
      }
      const raw = String(concepto)
      if (/000000/.test(raw) || /por definir/i.test(raw)) return true
      const list = this.conceptos || (this.detalle.gastosViaje && this.detalle.gastosViaje.conceptos) || []
      const found = list.find(c => String(c.id) === raw)
      return !!(found && (found.subcuenta === '000000' || /por definir/i.test(found.descripcion || '')))
    },
    abrirNuevoConcepto(idDocumento) {
      this.id_documento = idDocumento
      this.nuevo_conceptoo = ''
      this.dialogNewCon = true
    },
    updateNewConcept() {
      if (this.nuevo_conceptoo != '') {
        let data = {
          tipo: this.solicitud,
          id_documento: this.id_documento,
          concepto: this.nuevo_conceptoo
        }
        this.closeNewConcept()
        this.loading = true
        this.ws('post', 'contaActualizarConceptoDocumento', data)
          .then(res => {
            this.loading = false
            if (res.ok) {
              this.closeDetailFac()
              this.closeDetailChk()
              this.success = true
              this.msgSuccess = res.message
              this.recargarDetalleActual()
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
      }
      else {
        this.error = true
        this.msgError = 'Debe seleccionar un concepto disponible'
      }
    },
    recargarDetalleActual() {
      if (!this.idSolicitudActual) {
        this.closeDetail()
        return
      }
      this.showDetail(this.idSolicitudActual, this.tipoDetalleActual)
    },
    downloadData(doc) {
      let nombre = this.detalle.cajaChica[doc].nombre
      let data = this.detalle.cajaChica[doc].data
      if (data !== null && data !== '') {
        let mimetype = data.split(';')[0].split(':')[1]
        download(data, nombre, mimetype)
      }
      else {
        this.error = true
        this.msgError = 'El documento no se encuentra disponible'
      }
    },
    prepareDetailReq(data) {
      this.detalle.cajaChica.nombre = data.usuario.nombre + ' ' + data.usuario.apellido_paterno + ' ' +
                                      data.usuario.apellido_materno
      this.detalle.cajaChica.nombre = this.detalle.cajaChica.nombre.trim();
      this.detalle.cajaChica.puesto = data.usuario.puesto
      this.detalle.cajaChica.departamento = data.usuario.departamento
      this.detalle.cajaChica.oficina = data.usuario.ubicacion
      this.detalle.cajaChica.estado = data.solicitud.estado
      this.detalle.cajaChica.area = data.solicitud.area
      this.detalle.cajaChica.centro = data.solicitud.centro
      this.detalle.cajaChica.importe = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.cajaChica.letra = data.solicitud.letra
      this.detalle.cajaChica.detalle = data.solicitud.detalle
      this.detalle.cajaChica.empresa = data.solicitud.empresa
      this.detalle.cajaChica.observaciones = data.solicitud.observaciones
      this.detalle.cajaChica.pagare.nombre = data.solicitud.pagare.nombre
      this.detalle.cajaChica.pagare.data = data.solicitud.pagare.data
      this.detalle.cajaChica.responsiva.nombre = data.solicitud.responsiva.nombre
      this.detalle.cajaChica.responsiva.data = data.solicitud.responsiva.data
      this.detalle.cajaChica.firmas = data.firmas
      this.dialogDetReq = true
    },
    downloadDataInc(doc) {
      let nombre = this.detalle.cajaChica.incremento[doc].nombre
      let data = this.detalle.cajaChica.incremento[doc].data
      if (data !== null && data !== '') {
        let mimetype = data.split(';')[0].split(':')[1]
        download(data, nombre, mimetype)
      }
      else {
        this.error = true
        this.msgError = 'El documento no se encuentra disponible'
      }
    },
    prepareDetailInc(id, data) {
      this.detalle.cajaChica.incremento.id = id
      this.detalle.cajaChica.incremento.estado = data.solicitud.estado
      this.detalle.cajaChica.incremento.importe = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.cajaChica.incremento.letra = data.solicitud.letra
      this.detalle.cajaChica.incremento.observaciones = data.solicitud.observaciones
      this.detalle.cajaChica.incremento.pagare.nombre = data.solicitud.pagare.nombre
      this.detalle.cajaChica.incremento.pagare.data = data.solicitud.pagare.data
      this.detalle.cajaChica.incremento.responsiva.nombre = data.solicitud.responsiva.nombre
      this.detalle.cajaChica.incremento.responsiva.data = data.solicitud.responsiva.data
      this.detalle.cajaChica.incremento.firmas = data.firmas
      this.dialogDetInc = true
    },
    downloadDocumentRep(doc) {
      let nombre = this.detalle.reposicion.detalle_factura[doc].nombre
      let data = this.detalle.reposicion.detalle_factura[doc].data
      if (data !== null && data !== '') {
        let mimetype = data.split(';')[0].split(':')[1]
        download(data, nombre, mimetype)
      }
      else {
        this.error = true
        this.msgError = 'El documento no se encuentra disponible'
      }
    },
    closeDetailFac() {
      this.detalle.reposicion.detalle_factura = {
        index: '',
        id: '',
        tipo_gasto: null,
        pdf: { nombre: '', data: null },
        xml: { nombre: '', data: null },
        foto: { nombre: '', data: null },
        centro: null,
        concepto: '',
        razon_social: '',
        rfc: '',
        no_factura: '',
        proveedor_frontera: false,
        importe: '',
        descuento: '',
        iva: '',
        total: ''
      }
      this.dialogDetFac = false
    },
    showFacDetailRep(idx) {
      this.detalle.reposicion.detalle_factura.index = idx
      this.detalle.reposicion.detalle_factura.id = this.detalle.reposicion.facturas[idx].id
      this.detalle.reposicion.detalle_factura.tipo_gasto = this.detalle.reposicion.facturas[idx].tipo_gasto
      this.detalle.reposicion.detalle_factura.pdf.nombre = this.detalle.reposicion.facturas[idx].pdf.nombre
      this.detalle.reposicion.detalle_factura.pdf.data = this.detalle.reposicion.facturas[idx].pdf.data
      this.detalle.reposicion.detalle_factura.xml.nombre = this.detalle.reposicion.facturas[idx].xml.nombre
      this.detalle.reposicion.detalle_factura.xml.data = this.detalle.reposicion.facturas[idx].xml.data
      this.detalle.reposicion.detalle_factura.foto.nombre = this.detalle.reposicion.facturas[idx].foto.nombre
      this.detalle.reposicion.detalle_factura.foto.data = this.detalle.reposicion.facturas[idx].foto.data
      this.detalle.reposicion.detalle_factura.centro = this.detalle.reposicion.facturas[idx].centro
      this.detalle.reposicion.detalle_factura.concepto = this.detalle.reposicion.facturas[idx].concepto
      this.detalle.reposicion.detalle_factura.razon_social = this.detalle.reposicion.facturas[idx].razon_social
      this.detalle.reposicion.detalle_factura.rfc = this.detalle.reposicion.facturas[idx].rfc
      this.detalle.reposicion.detalle_factura.no_factura = this.detalle.reposicion.facturas[idx].no_factura
      this.detalle.reposicion.detalle_factura.importe = this.detalle.reposicion.facturas[idx].importe
      this.detalle.reposicion.detalle_factura.descuento = this.detalle.reposicion.facturas[idx].descuento
      this.detalle.reposicion.detalle_factura.iva = this.detalle.reposicion.facturas[idx].iva
      this.detalle.reposicion.detalle_factura.total = this.detalle.reposicion.facturas[idx].total
      this.detalle.reposicion.detalle_factura.importe = this.detalle.reposicion.detalle_factura.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.detalle_factura.descuento = this.detalle.reposicion.detalle_factura.descuento.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.detalle_factura.iva = this.detalle.reposicion.detalle_factura.iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.detalle_factura.total = this.detalle.reposicion.detalle_factura.total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.dialogDetFac = true
    },
    prepareDetailRep(data) {
      this.detalle.reposicion.solicitud.monto = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.solicitud.empresa = data.solicitud.empresa
      this.detalle.reposicion.solicitud.centro = data.solicitud.centro
      this.detalle.reposicion.usuario.unidad = data.usuario.unidad
      this.detalle.reposicion.usuario.plaza = data.usuario.plaza
      this.detalle.reposicion.usuario.beneficiario = data.usuario.nombre
      this.detalle.reposicion.general.tipo_solicitud = data.reposicion.tipo_solicitud
      this.detalle.reposicion.general.tipo_pago = data.reposicion.tipo_pago
      this.detalle.reposicion.general.banco = data.reposicion.banco
      this.detalle.reposicion.general.cuenta = data.reposicion.cuenta
      this.detalle.reposicion.general.tarjeta = data.reposicion.tarjeta
      this.detalle.reposicion.general.clabe = data.reposicion.clabe
      this.detalle.reposicion.general.importe_total = data.reposicion.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.facturas = data.facturas
      this.detalle.reposicion.resumen.no_facturas = data.facturas.length
      let subtotal = 0
      let iva = 0
      for (let i = 0; i < data.facturas.length; i++) {
        subtotal += parseFloat(parseFloat(data.facturas[i].importe).toFixed(2))
        iva += parseFloat(parseFloat(data.facturas[i].iva).toFixed(2))
      }
      this.detalle.reposicion.resumen.subtotal = subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.resumen.iva = iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.reposicion.firmas = data.firmas
      this.conceptos = data.conceptos
      this.dialogDetRep = true
    },
    closeDetailChk() {
      this.detalle.gastosViaje.detalle_factura = {
        index: '',
        tipo_gasto: '',
        centro: null,
        concepto: '',
        detalle_no: '',
        pdf: { nombre: '', data: null },
        xml: { nombre: '', data: null },
        foto: { nombre: '', data: null },
        rfc: '',
        beneficiario: '',
        folio: '',
        uuid: '',
        subtotal: '',
        descuento: '',
        iva: '',
        total: ''
      }
      this.dialogDetChk = false
    },
    downloadDocumentAnt(format) {
      this.loading = true
      setTimeout(() => {
        let data = {
          id: this.detalle.gastosViaje.id,
          id_com: this.detalle.gastosViaje.detalle_comprobante.id,
          tipo: format
        }
        this.ws('get', 'contaDescargarDocumentoAnticipoViaje', data)
          .then(res => {
            if (res.ok) {
              let doc = res.data.documento
              let nombre = doc.nombre
              let data = doc.data
              if (data !== null && data !== '') {
                let mimetype = data.split(';')[0].split(':')[1]
                download(data, nombre, mimetype)
              }
              else {
                this.error = true
                this.msgError = 'El documento no se encuentra disponible'
              }
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 500)
    },
    showDetailChk(idx) {
      this.detalle.gastosViaje.detalle_comprobante.index = idx
      this.detalle.gastosViaje.detalle_comprobante.id = this.detalle.gastosViaje.comprobantes[idx].id
      this.detalle.gastosViaje.detalle_comprobante.tipo_gasto = this.detalle.gastosViaje.comprobantes[idx].tipo_gasto
      this.detalle.gastosViaje.detalle_comprobante.centro = this.detalle.gastosViaje.comprobantes[idx].centro
      this.detalle.gastosViaje.detalle_comprobante.concepto = this.detalle.gastosViaje.comprobantes[idx].concepto
      this.detalle.gastosViaje.detalle_comprobante.detalle_no = this.detalle.gastosViaje.comprobantes[idx].detalle_no
      this.detalle.gastosViaje.detalle_comprobante.rfc = this.detalle.gastosViaje.comprobantes[idx].rfc
      this.detalle.gastosViaje.detalle_comprobante.beneficiario = this.detalle.gastosViaje.comprobantes[idx].beneficiario
      this.detalle.gastosViaje.detalle_comprobante.folio = this.detalle.gastosViaje.comprobantes[idx].folio
      this.detalle.gastosViaje.detalle_comprobante.uuid = this.detalle.gastosViaje.comprobantes[idx].uuid
      this.detalle.gastosViaje.detalle_comprobante.subtotal = this.detalle.gastosViaje.comprobantes[idx].subtotal
      this.detalle.gastosViaje.detalle_comprobante.descuento = this.detalle.gastosViaje.comprobantes[idx].descuento
      this.detalle.gastosViaje.detalle_comprobante.iva = this.detalle.gastosViaje.comprobantes[idx].iva
      this.detalle.gastosViaje.detalle_comprobante.total = this.detalle.gastosViaje.comprobantes[idx].total
      this.detalle.gastosViaje.detalle_comprobante.subtotal = this.detalle.gastosViaje.detalle_comprobante.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.detalle_comprobante.descuento = this.detalle.gastosViaje.detalle_comprobante.descuento.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.detalle_comprobante.iva = this.detalle.gastosViaje.detalle_comprobante.iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.detalle_comprobante.total = this.detalle.gastosViaje.detalle_comprobante.total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.dialogDetChk = true
    },
    prepareDetailAnt(id, data) {
      this.detalle.gastosViaje.id = id
      this.detalle.gastosViaje.beneficiario = data.usuario.beneficiario
      this.detalle.gastosViaje.puesto = data.usuario.puesto
      this.detalle.gastosViaje.empresa = data.usuario.empresa
      this.detalle.gastosViaje.plaza = data.usuario.plaza
      this.detalle.gastosViaje.departamento = data.usuario.departamento
      this.detalle.gastosViaje.estado = data.solicitud.estado
      this.detalle.gastosViaje.centro = data.solicitud.centro
      this.detalle.gastosViaje.destino = data.solicitud.destino
      this.detalle.gastosViaje.motivo_viaje = data.solicitud.motivo_viaje
      this.detalle.gastosViaje.fecha_salida = data.solicitud.fecha_salida
      this.detalle.gastosViaje.fecha_regreso = data.solicitud.fecha_regreso
      let fecha_salida = moment(this.detalle.gastosViaje.fecha_salida, 'YYYY-MM-DD')
      let fecha_regreso = moment(this.detalle.gastosViaje.fecha_regreso, 'YYYY-MM-DD')
      this.detalle.gastosViaje.dias_viaje = parseInt(fecha_regreso.diff(fecha_salida, 'days')) + 1
      this.detalle.gastosViaje.importe_total = data.solicitud.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.tipo_solicitud = data.solicitud.tipo_solicitud
      this.detalle.gastosViaje.banco = data.usuario.banco
      this.detalle.gastosViaje.cuenta = data.usuario.cuenta
      this.detalle.gastosViaje.tarjeta = data.usuario.tarjeta
      this.detalle.gastosViaje.clabe = data.usuario.clabe
      this.detalle.gastosViaje.centros = data.centros
      this.detalle.gastosViaje.conceptos = data.conceptos
      this.detalle.gastosViaje.conceptos_sat = data.conceptos_sat
      this.detalle.gastosViaje.detalles_no = data.detalles_no
      this.detalle.gastosViaje.comprobantes = data.comprobantes
      let subtotal = 0
      let iva = 0
      let total = 0
      for (let i = 0; i < this.detalle.gastosViaje.comprobantes.length; i++) {
        subtotal += parseFloat(this.detalle.gastosViaje.comprobantes[i].subtotal.toFixed(2))
        iva += parseFloat(this.detalle.gastosViaje.comprobantes[i].iva.toFixed(2))
        total += parseFloat(this.detalle.gastosViaje.comprobantes[i].total.toFixed(2))
      }
      this.detalle.gastosViaje.resumen.no_comprobantes = this.detalle.gastosViaje.comprobantes.length
      this.detalle.gastosViaje.resumen.subtotal = subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.resumen.iva = iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.resumen.neto = total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalle.gastosViaje.firmas_anticipo = data.firmas_anticipo
      this.detalle.gastosViaje.firmas_comprobante = data.firmas_comprobante
      this.conceptos = data.conceptos
      this.dialogDetAnt = true
    },
    showDetail(id, tipo) {
      this.idSolicitudActual = id
      this.tipoDetalleActual = tipo
      if (this.solicitud === 'cajaChica') {
        this.loading = true
        this.ws('get', 'contaDetalleMovimientoCajaChica', { id, tipo })
          .then(res => {
            if (res.ok) {
              if (tipo === 'Alta') {
                this.prepareDetailReq(res.data)
              }
              else if (tipo === 'Incremento') {
                this.prepareDetailInc(id, res.data)
              }
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
      else if (this.solicitud === 'reposicion') {
        this.loading = true
        this.ws('get', 'contaDetalleReposicionCajaChica', { id })
          .then(res => {
            if (res.ok) {
              this.prepareDetailRep(res.data)
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
      else if (this.solicitud === 'gastosViaje') {
        this.loading = true
        this.ws('get', 'contaDetalleSolicitudAnticipoViaje', { id })
          .then(res => {
            if (res.ok) {
              this.prepareDetailAnt(id, res.data)
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    downloadCSVReport() {
      if (this.solicitud === 'cajaChica') {
        let headers = [
          'Id. Solicitud',
          'Usuario',
          'Tipo',
          'Estado',
          'Importe',
          'Fecha de Registro',
          'Fecha de Actualización',
          'Pagaré',
          'Responsiva'
        ]
        let text = headers.join(',') + '\n'
        for (var i = 0; i < this.registros.cajaChica.length; i++) {
          text += this.registros.cajaChica[i].id_seg + ','
          text += this.registros.cajaChica[i].usuario_creacion + ','
          text += this.registros.cajaChica[i].tipo + ','
          text += this.registros.cajaChica[i].estado + ','
          text += this.registros.cajaChica[i].importe + ','
          text += this.registros.cajaChica[i].fecha_registro + ','
          text += this.registros.cajaChica[i].fecha_actualizacion + ','
          text += this.registros.cajaChica[i].pagare + ','
          text += this.registros.cajaChica[i].responsiva + ','
          text = text.trim(',') + '\n'
        }
        download(text, 'resumen_cajaChica.csv', 'text/csv')
      }
      else if (this.solicitud === 'reposicion') {
        let headers = [
          'Id. Solicitud',
          'Usuario',
          'Tipo de Solicitud',
          'Tipo de Pago',
          'No. Facturas',
          'Importe Total',
          'Estado',
          'Fecha de Registro',
          'Fecha de Actualización'
        ]
        let text = headers.join(',') + '\n'
        for (var i = 0; i < this.registros.reposicion.length; i++) {
          text += this.registros.reposicion[i].id_seg + ','
          text += this.registros.reposicion[i].usuario_creacion + ','
          text += this.registros.reposicion[i].tipo_solicitud + ','
          text += this.registros.reposicion[i].tipo_pago + ','
          text += this.registros.reposicion[i].no_facturas + ','
          text += this.registros.reposicion[i].importe_total + ','
          text += this.registros.reposicion[i].estado + ','
          text += this.registros.reposicion[i].fecha_registro + ','
          text += this.registros.reposicion[i].fecha_actualizacion + ','
          text = text.trim(',') + '\n'
        }
        download(text, 'resumen_reposicion.csv', 'text/csv')
      }
      else if (this.solicitud === 'gastosViaje') {
        let headers = [
          'Id. Solicitud',
          'Usuario',
          'Estado de Anticipo',
          'Estado de Comprobación',
          'Fecha de Salids',
          'Fecha de Regreso',
          'Importe de Anticipo',
          'Importe Comprobado',
          'Importe Restante',
          'Fecha de Registro',
          'Fecha de Actualización'
        ]
        let text = headers.join(',') + '\n'
        for (var i = 0; i < this.registros.gastosViaje.length; i++) {
          text += this.registros.gastosViaje[i].id_seg + ','
          text += this.registros.gastosViaje[i].usuario_creacion + ','
          text += this.registros.gastosViaje[i].estado + ','
          text += this.registros.gastosViaje[i].estado_comprobacion + ','
          text += this.registros.gastosViaje[i].fecha_salida + ','
          text += this.registros.gastosViaje[i].fecha_regreso + ','
          text += this.registros.gastosViaje[i].importe_anticipo + ','
          text += this.registros.gastosViaje[i].importe_comprobado + ','
          text += this.registros.gastosViaje[i].importe_restante + ','
          text += this.registros.gastosViaje[i].fecha_registro + ','
          text += this.registros.gastosViaje[i].fecha_actualizacion + ','
          text = text.trim(',') + '\n'
        }
        download(text, 'resumen_gastosViaje.csv', 'text/csv')
      }
    }
  }
}
</script>
